export enum ContractorUserRole {
  ADMIN = 9,
  MANAGER = 10,
  TECHNICIAN = 11,
}
